module.exports = __webpack_public_path__ + "img/kid.50d321cb.jpg";